import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 993BB952-DF8E-47E6-AF9A-1FCBF15C6B63
 * name egg
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/egg.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const EggIcon = createSvgIcon(<><path d="M19.5,14.5A7.5,7.5 0 0,1 12,22A7.5,7.5 0 0,1 4.5,14.5C4.5,10.36 7.86,2 12,2C16.14,2 19.5,10.36 19.5,14.5Z" /></>, 'EggIcon');
export default EggIcon